/* Bundomanija — mali pomoćni skript: animacija pojavljivanja i odbrojavanje */
(function () {
  function initFade(root) {
    var els = (root || document).querySelectorAll('.bm-fade:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-bm-countdown]').forEach(function (el) {
      if (el.dataset.bmReady) return;
      el.dataset.bmReady = '1';
      var raw = (el.getAttribute('data-bm-countdown') || '').trim().replace(' ', 'T');
      var end = new Date(raw);
      var section = el.closest('[data-bm-countdown-section]');
      if (isNaN(end.getTime())) { el.hidden = true; return; }
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
          m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function tick() {
        var diff = Math.max(0, end.getTime() - Date.now());
        var sec = Math.floor(diff / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor((sec % 86400) / 3600));
        m.textContent = pad(Math.floor((sec % 3600) / 60));
        s.textContent = pad(sec % 60);
        if (diff <= 0) {
          clearInterval(timer);
          if (section && section.dataset.hideExpired === 'true' && !window.Shopify?.designMode) {
            section.hidden = true;
          }
        }
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  function init(root) { initFade(root); initCountdowns(root); }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
